<svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.73 98.08"
    ><defs
        ><style>
            .cls-1 {
                fill: #1d1d1b;
            }
        </style></defs
    ><g id="Ebene_1-2"
        ><g
            ><g
                ><path
                    class="cls-1"
                    d="M67.98,75.36H1.75c-.97,0-1.75-.78-1.75-1.75v-18.43c0-.97,.78-1.75,1.75-1.75H67.98c.97,0,1.75,.78,1.75,1.75v18.43c0,.97-.78,1.75-1.75,1.75ZM3.5,71.86h62.73v-14.93H3.5v14.93Z"
                /><path
                    class="cls-1"
                    d="M67.98,48.64H1.75c-.97,0-1.75-.78-1.75-1.75V28.47c0-.97,.78-1.75,1.75-1.75H67.98c.97,0,1.75,.78,1.75,1.75v18.43c0,.97-.78,1.75-1.75,1.75ZM3.5,45.14h62.73v-14.93H3.5v14.93Z"
                /><path
                    class="cls-1"
                    d="M67.98,21.93H1.75c-.97,0-1.75-.78-1.75-1.75V1.75C0,.78,.78,0,1.75,0H67.98c.97,0,1.75,.78,1.75,1.75V20.18c0,.97-.78,1.75-1.75,1.75ZM3.5,18.43h62.73V3.5H3.5v14.93Z"
                /><path
                    class="cls-1"
                    d="M34.81,98.08c-.45,0-.9-.17-1.24-.51l-8.02-8.02c-.68-.68-.68-1.79,0-2.47l8.02-8.02c.68-.68,1.79-.68,2.47,0l8.02,8.02c.68,.68,.68,1.79,0,2.47l-8.02,8.02c-.34,.34-.79,.51-1.24,.51Zm-5.54-9.77l5.54,5.54,5.54-5.54-5.54-5.54-5.54,5.54Z"
                /><path
                    class="cls-1"
                    d="M34.86,82.04c-.97,0-1.75-.78-1.75-1.75v-5.83c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v5.83c0,.97-.78,1.75-1.75,1.75Z"
                /><g
                    ><path
                        class="cls-1"
                        d="M26.9,90.06H8.2c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75H26.9c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
                    /><path
                        class="cls-1"
                        d="M61.41,90.06h-18.7c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h18.7c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
                    /></g
                ><g
                    ><path
                        class="cls-1"
                        d="M24.16,64.12H11.06c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h13.1c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
                    /><path
                        class="cls-1"
                        d="M30.4,64.11c-.12,0-.23,0-.35-.03-.11-.02-.22-.06-.32-.1-.11-.05-.21-.1-.31-.16-.09-.07-.18-.14-.26-.22-.08-.08-.16-.17-.22-.27-.06-.09-.12-.19-.16-.3-.04-.1-.08-.22-.1-.33-.02-.11-.03-.22-.03-.34,0-.46,.18-.91,.51-1.23,.08-.09,.17-.16,.26-.22,.1-.07,.2-.12,.31-.16,.1-.05,.21-.08,.32-.1,.57-.11,1.18,.07,1.58,.48,.33,.32,.52,.77,.52,1.23,0,.12-.02,.23-.04,.34-.02,.11-.05,.23-.1,.33-.04,.11-.1,.21-.16,.3-.06,.1-.14,.19-.22,.27-.32,.33-.77,.51-1.23,.51Z"
                    /></g
                ><g
                    ><path
                        class="cls-1"
                        d="M24.16,37.35H11.06c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h13.1c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
                    /><path
                        class="cls-1"
                        d="M30.4,37.35c-.46,0-.91-.19-1.24-.52-.33-.32-.51-.78-.51-1.23,0-.12,0-.23,.03-.35,.02-.11,.06-.22,.1-.33,.04-.1,.1-.2,.16-.3,.06-.09,.14-.18,.22-.26s.17-.16,.26-.22c.1-.06,.2-.12,.31-.16,.1-.05,.21-.08,.32-.1,.57-.11,1.17,.07,1.58,.48,.08,.08,.16,.17,.22,.26,.06,.1,.12,.2,.16,.3,.05,.11,.08,.22,.1,.33,.02,.12,.04,.23,.04,.35,0,.46-.19,.91-.52,1.23-.33,.33-.78,.52-1.23,.52Z"
                    /></g
                ><g
                    ><path
                        class="cls-1"
                        d="M24.16,10.58H11.06c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h13.1c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
                    /><path
                        class="cls-1"
                        d="M30.4,10.58c-.46,0-.91-.19-1.24-.52-.08-.08-.16-.17-.22-.26-.06-.1-.12-.2-.16-.3-.04-.11-.08-.22-.1-.33-.02-.11-.03-.23-.03-.34,0-.12,0-.23,.03-.35,.02-.11,.06-.22,.1-.32,.04-.11,.1-.21,.16-.31,.06-.09,.14-.18,.22-.26,.65-.65,1.81-.66,2.47,0,.08,.08,.16,.17,.22,.26,.06,.1,.12,.2,.16,.31,.05,.1,.08,.21,.1,.32,.02,.12,.04,.23,.04,.35,0,.11-.02,.23-.04,.34-.02,.11-.05,.22-.1,.33-.04,.1-.1,.2-.16,.3-.06,.09-.14,.18-.22,.26-.33,.33-.78,.52-1.23,.52Z"
                    /></g
                ></g
            ><g
                ><path
                    class="cls-1"
                    d="M5.13,29.71c-.97,0-1.75-.78-1.75-1.75v-6.9c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v6.9c0,.97-.78,1.75-1.75,1.75Z"
                /><path
                    class="cls-1"
                    d="M64.59,29.71c-.97,0-1.75-.78-1.75-1.75v-6.9c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v6.9c0,.97-.78,1.75-1.75,1.75Z"
                /></g
            ><g
                ><path
                    class="cls-1"
                    d="M5.13,56.24c-.97,0-1.75-.78-1.75-1.75v-6.9c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v6.9c0,.97-.78,1.75-1.75,1.75Z"
                /><path
                    class="cls-1"
                    d="M64.59,56.24c-.97,0-1.75-.78-1.75-1.75v-6.9c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v6.9c0,.97-.78,1.75-1.75,1.75Z"
                /></g
            ></g
        ></g
    ></svg
>
